import icon from 'vue-svgicon';

icon.register({
    'regular/night-moon-new': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M11.437 11.959a11.254 11.254 0 0 1 7.876-10.733 11.25 11.25 0 1 0 0 21.466 11.254 11.254 0 0 1-7.876-10.733z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
